var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 18"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m5.853 8.916 1.007-.358a.42.42 0 0 1 .28 0l1.007.358-.016-1.112c0-.099.03-.196.088-.275l.639-.889-1.019-.33a.43.43 0 0 1-.224-.17L7 5.231l-.615.907a.43.43 0 0 1-.224.171l-1.018.33.638.889c.057.08.089.176.088.275zM5.425 10a.44.44 0 0 1-.445-.436v-.02L5 7.948l-.915-1.28a.463.463 0 0 1 .09-.63.4.4 0 0 1 .13-.07l1.46-.472.882-1.305a.42.42 0 0 1 .707 0l.88 1.305 1.462.473a.455.455 0 0 1 .219.699L9 7.948l.02 1.596a.44.44 0 0 1-.425.456q-.076 0-.147-.025L7 9.46l-1.449.515a.4.4 0 0 1-.126.025"
}), /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 16,
  x: 1,
  y: 1,
  stroke: "currentColor",
  strokeWidth: 2,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14 10h6v1h-6zM6 13h14v1H6z"
}))));
export default SvgCard;